import { createFeatureSelector, createSelector } from '@ngrx/store';

import { RedirectionState } from './RedirectionState';



export class RedirectionStateSelector {
  static readonly getRedirectionState = createFeatureSelector<RedirectionState>('redirectionResource');

  static getRedirectionInfo = createSelector(
    RedirectionStateSelector.getRedirectionState,
    state => state
  );

}
